
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe17 as ObiHydraulicPipe17Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-17.js';
 
 
 

 
 export const ObiHydraulicPipe17 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-17',
   elementClass: ObiHydraulicPipe17Element,
   events: {
     
   }
  });
 
 